import React from 'react'
import ProfilePicture from '../App/ProfilePicture'
import relativeTimeAgo from '../../utils/relativeTimeAgo'


const getMessageFields = (message) => {
    const months_arr = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const user_first_name = message.user_id?.first_name || '';
    const user_last_name = message.user_id?.last_name || '';
    const user_full_name = `${user_first_name} ${user_last_name}`;
    const year_of_collaborating = new Date(message.created_at).getFullYear();
    const month_of_collaborating = months_arr[new Date(message.created_at).getMonth()];
    const day_of_collaborating = new Date(message.created_at).getDate();
    const actual_time_of_collaborating = `${day_of_collaborating} ${month_of_collaborating} ${year_of_collaborating}`;
    
    return {
        months_arr, 
        user_first_name, 
        user_last_name,
        user_full_name, 
        year_of_collaborating, 
        month_of_collaborating, 
        day_of_collaborating, 
        actual_time_of_collaborating
    }
}

export function SenderMessageCard({message}) {
    return (
     <div className="w-full flex justify-end pl-14" key={message._id}>
        <div>
            <div className="w-full block">
            <p className="bg-green-100 p-2 rounded-lg max-w-[50%] break-words whitespace-pre-wrap">
                {message.message_text}
            </p>
            <p className="text-xs text-right text-gray-500">{relativeTimeAgo(message.created_at)}</p>
            </div>
        </div>
    </div>
  )
}

export function ReceiverMessageCard({message}) {
    const { 
        user_full_name, 
    } = getMessageFields(message);
    return (
        <div className="w-full mr-2 flex justify-start items-center" key={message._id}>
            <ProfilePicture className='mr-2 flex-shrink-0 w-12' user={message.user_id}/>
            <div>
                <p className="text-secondary text-xs text-left font-bold">
                    {user_full_name}
                </p>  
                <div className="w-full block">
                    <p className="bg-blue-100 p-2 rounded-lg max-w-[50%] break-words whitespace-pre-wrap">
                    {message.message_text}
                    </p>
                    <p className="text-xs text-left text-gray-500">{relativeTimeAgo(message.created_at)}</p>
                </div>
            </div>
      </div>
      
    )
}


export function ChatNotification({notification}) {
    
    const { 
        user_full_name, 
    } = getMessageFields(notification);
    return (
        <div className="w-full flex justify-center" key={notification._id}>
            <p className="text-sm text-secondary text-gray-500">
                <span className="font-bold text-xs">{user_full_name} </span> 
                {notification.notification === 'user_joined' && 'joined the conversation'}
                {notification.notification === 'user_left' && 'left the conversation'}
            </p>
        </div>
    )
}

